import React, { useEffect, useState } from 'react';
import QuarterlyPerformance from '../components/QuarterlyPerformance';
import AssetBreakdownTwo from '../components/AssetBreakdownTwo';
import ChainSplit from '../components/ChainSplit';
import AssetBreakdown from '../components/AssetBreakdown';
import { getQuarterlyPerformance } from '../../../store/defi/walletDetailSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  exchangeOverviewSelector,
  getExchangeAssetInfo, getExchangeAssetInfoByAccountID,
  getExchangePerformanceSummary, getExchangePerformanceSummaryByAccount, getQuarterlyPerformanceByAccountID,
} from '../../../store/exchanges/overview';

const Overview = ({ account }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const {
    quarterly_performance,
    performance_summary,
    available_exchange_providers,
    balance_breakdown,
    exchange_asset_breakdown,
    exchange_split,
    future_asset_overview,
    overall_asset_breakdown,
    spot_asset_overview,
  } = useSelector(exchangeOverviewSelector);
  const [quarterlyPerformance, setQuarterlyPerformance] = useState();
  const [performanceSummary, setPerformanceSummary] = useState();

  useEffect(() => {
    if (account) {
      dispatch(getExchangeAssetInfoByAccountID(account));
      dispatch(getQuarterlyPerformanceByAccountID(account));
      dispatch(getExchangePerformanceSummaryByAccount(account));
    }
  }, [account, dispatch]);

  useEffect(() => {
    setQuarterlyPerformance(quarterly_performance);
    setPerformanceSummary(performance_summary);
  }, [quarterly_performance, performance_summary]);

  useEffect(() => {
    setLoading(true);

    let timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="overview" style={{ paddingBottom: '12rem' }}>
      <div className="" style={{ display: 'flex', gap: '0.8%' }}>
        <div className="" style={{ width: '66%' }}>
          <AssetBreakdown
            chain_asset_breakdown={exchange_asset_breakdown}
            available_chains={available_exchange_providers}
            title="Asset Breakdown"
          />
        </div>
        <div className="" style={{ flexGrow: 1, overflowX: 'hidden' }}>
          <ChainSplit chain_total_amounts={overall_asset_breakdown} title="Chain Split %" />
        </div>
      </div>
    </div>
  );
};

export default Overview;
